













import Vue, { PropType } from 'vue';
// import * as tools from '@/modules/tools';
// import { ItemData } from '@/modules/exhibitor/item';
// import { Story } from '@/modules/exhibitor/story';
// import { Option } from 'mostra';

import {
  // Option,
  // Story,
  Item,
  // story,
} from 'mostra';

// import { Option, storyOptions } from '@/modules/options';
// import { v4 } from 'uuid';
//
// const {
//   createStoryTitle,
//   createStoryDescription,
//   createStoryImage,
//   createStoryVideo,
// } = story;
//
// const generateListKey = () => v4();
//
// type ItemStoryItem = {
//   id: string,
//   story: Story,
// }
//
// export type DataType = {
//   storyOptions: Option;
// };

export default Vue.extend({
  name: 'GItemStoryForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    item: {
      type: Object as PropType<Item>,
      required: true,
    },
    // addNewStory: {
    //   type: Function as PropType<Function>,
    //   default: () => false,
    // },
    // onDelete: {
    //   type: Function as PropType<Function>,
    // },
    // onUp: {
    //   type: Function as PropType<Function>,
    // },
    // onDown: {
    //   type: Function as PropType<Function>,
    // },
  },
  // data(): DataType {
  //   return {
  //     storyOptions: [
  //       { value: 1, text: '見出し' },
  //       { value: 2, text: '説明文' },
  //       { value: 3, text: '画像' },
  //       { value: 4, text: '動画(YouTube)' },
  //     ],
  //   };
  // },
  // computed: {
  //   stories(): ItemStoryItem[] {
  //     return this.item.data.stories.map((st: Story) => (
  //       {
  //         id: generateListKey(),
  //         story: st,
  //       }
  //     ));
  //   },
  // },
  // methods: {
  //   addNewStory(val: number): void {
  //     if (this.item === null) return;
  //     switch (val) {
  //       case 1:
  //         this.item.data.stories.push(createStoryTitle());
  //         break;
  //       case 2:
  //         this.item.data.stories.push(createStoryDescription());
  //         break;
  //       case 3:
  //         this.item.data.stories.push(createStoryImage());
  //         break;
  //       case 4:
  //         this.item.data.stories.push(createStoryVideo());
  //         break;
  //       default:
  //     }
  //   },
  //   onDeleteStory(list: Story[], index: number) {
  //     tools.deleteList(list, index);
  //     // this.onDelete(list, index);
  //   },
  //   onUpStory(list: Story[], index: number) {
  //     // this.onUp(list, index);
  //     tools.upList(list, index);
  //   },
  //   onDownStory(list: Story[], index: number) {
  //     tools.downList(list, index);
  //     // this.onDown(list, index);
  //   },
  // },
});
